<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="false">
    <mat-toolbar>
      <img src="assets/acs-ag-logo.svg" class="acs-logo" alt="ACS AG Logo">
    </mat-toolbar>
    <mat-nav-list>
      <a mat-list-item routerLink='/app/classes' (click)="drawer.toggle()">
        <mat-icon>collections_bookmark</mat-icon>Classes
      </a>
      <a mat-list-item routerLink='/app/printers' (click)="drawer.toggle()">
        <mat-icon>print</mat-icon>Printers
      </a>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar color="primary">
      <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <span>{{'main.title' | translate}}</span>

      <!-- used to separate left side menu from right side Elements -->
      <span class="spacer"></span>


      <!-- Language Switcher -->
      <div class="languageSwitcher">
        <button mat-button [matMenuTriggerFor]="languageSwitcher">
          <mat-icon>language</mat-icon>
          <span class="language">{{translateService.currentLang}}</span>
        </button>
        <mat-menu #languageSwitcher="matMenu">
          <button mat-menu-item (click)="translateService.use('de')">
            <mat-icon>language</mat-icon><span>{{'language.de' | translate}}</span>
          </button>
          <button mat-menu-item (click)="translateService.use('en')">
            <mat-icon>language</mat-icon><span>{{'language.en' | translate}}</span>
          </button>
        </mat-menu>
      </div>

      <!-- Authentication Menu -->
      <button mat-icon-button [matMenuTriggerFor]="authMenu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #authMenu="matMenu">
        @if ((principal | async)) {
          <a mat-menu-item href="{{accountUrl}}">
            <mat-icon>account_circle</mat-icon>
            <span>Account</span>
          </a>
        }

        @if ((principal | async)) {
          <button mat-menu-item (click)="logout()">
            <mat-icon>exit_to_app</mat-icon>
            Logout Admin
          </button>
        }

        @if (!(principal | async)) {
          <button mat-menu-item (click)="login()">
            <mat-icon>face</mat-icon>
            Login
          </button>
        }
      </mat-menu>
    </mat-toolbar>
  </mat-sidenav-content>
</mat-sidenav-container>